const publicURL = "/assets/pdf/";

function getPublicUrl(fileName) {
  return `${publicURL}${fileName}`;
}

export const privacyPolicyPdf = getPublicUrl("Eight-8 Privacy Policy.pdf");
